var map = {
	"./client/pages/404.vue": 25747,
	"./client/pages/admin/acl/index.vue": 22470,
	"./client/pages/admin/media/index.vue": 56368,
	"./client/pages/admin/order/index.vue": 38666,
	"./client/pages/admin/product/create.vue": 7485,
	"./client/pages/admin/product/edit/[id].vue": 44237,
	"./client/pages/admin/product/index.vue": 30463,
	"./client/pages/admin/user/index.vue": 92738,
	"./client/pages/admin/vendor/create.vue": 37587,
	"./client/pages/admin/vendor/edit/[id].vue": 41800,
	"./client/pages/admin/vendor/index.vue": 393,
	"./client/pages/error/index.vue": 3019,
	"./client/pages/index.vue": 93884,
	"./client/pages/notifications/index.vue": 49462,
	"./client/pages/payments-playground.vue": 17578,
	"./client/pages/store/checkout/complete/index.vue": 89746,
	"./client/pages/store/checkout/index.vue": 48014,
	"./client/pages/store/checkout/orderComplete.vue": 76463,
	"./client/pages/store/checkout/orderpg.vue": 34488,
	"./client/pages/store/checkout/standard.vue": 83773,
	"./client/pages/store/index.vue": 65675,
	"./client/pages/store/product/[productId].vue": 70979,
	"./client/pages/store/vendor/[id].vue": 80637,
	"./client/pages/store/vendor/[vendorId].vue": 32942,
	"./client/pages/store/vendor/index.vue": 67303,
	"./client/pages/styleguide.vue": 34964,
	"./client/pages/user/activation.vue": 33228,
	"./client/pages/user/dashboard/conversations.vue": 41557,
	"./client/pages/user/dashboard/dashboard.vue": 41198,
	"./client/pages/user/dashboard/help.vue": 79068,
	"./client/pages/user/dashboard/notifications.vue": 82346,
	"./client/pages/user/dashboard/orders.vue": 94244,
	"./client/pages/user/dashboard/payments.vue": 56293,
	"./client/pages/user/dashboard/profile.vue": 83046,
	"./client/pages/user/dashboard/reviews.vue": 51760,
	"./client/pages/user/dashboard/vendor/dashboard.vue": 61045,
	"./client/pages/user/dashboard/vendor/orders.vue": 63273,
	"./client/pages/user/dashboard/vendor/products.vue": 47287,
	"./client/pages/user/dashboard/vendor/profile.vue": 26452,
	"./client/pages/user/dashboard/vendor/reviews.vue": 40952,
	"./client/pages/user/login.vue": 45062
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6427;